import './navigation';
import './header';
import './ajax-add-to-cart';
import './select';
import './tirePopup';
import './share';
import './pricing';

$(document).ready(function () {
    $('.itemdetailtable tbody td').each(function () {
        var cellText = $(this).html(); // Pobierz zawartość HTML komórki
        var values = cellText.split('\n'); // Podziel wartości na osobne elementy
        var newText = values.join('<br />'); // Połącz wartości za pomocą <br />
        $(this).html(newText); // Ustaw nową zawartość komórki
    });
});
